/* VITALLY · tema Shopify. Comportamiento compartido: revelado al hacer
   scroll, entrada «La V que brota», puntero de marca, cabecera (sombra,
   desplegables y cajón móvil), CTA fija de los programas y test. */
(function () {
  "use strict";

  var raiz = document.documentElement;
  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var editor = window.Shopify && window.Shopify.designMode;

  /* ── Revelado ─────────────────────────────────────────────
     El velo solo existe con html.revela-vivo y SIEMPRE tiene salida por
     tiempo: si el observador no responde (pestaña oculta, equipo lento),
     todo aparece igual a los 2,5 s. */
  function revelar() {
    var nodos = document.querySelectorAll("[data-reveal]:not(.is-in)");
    if (!nodos.length) return;
    if (reducido || editor || !("IntersectionObserver" in window)) {
      nodos.forEach(function (n) { n.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("is-in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );
    nodos.forEach(function (n) {
      var d = n.getAttribute("data-delay");
      if (d) n.style.transitionDelay = d + "ms";
      io.observe(n);
    });
    raiz.classList.add("revela-vivo");
    var soltar = function () {
      document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) n.classList.add("is-in");
      });
    };
    setTimeout(soltar, 2500);
    document.addEventListener("visibilitychange", soltar);
  }

  /* ── Entrada «El nombre» (una vez por sesión) ─────────── */
  function entrada() {
    var intro = document.querySelector(".intro");
    if (!intro) return;
    if (!raiz.classList.contains("show-intro")) {
      intro.remove();
      return;
    }
    try { sessionStorage.setItem("vitally-intro", "1"); } catch (e) {}
    var cerrada = false;
    var salir = function () {
      if (cerrada) return;
      cerrada = true;
      intro.classList.add("is-leaving");
      setTimeout(function () {
        raiz.classList.remove("show-intro");
        intro.remove();
      }, 720);
    };
    // Cualquier gesto la salta: clic, tecla, rueda o toque.
    ["pointerdown", "keydown", "wheel", "touchstart"].forEach(function (ev) {
      window.addEventListener(ev, salir, { once: true, passive: true });
    });
    setTimeout(salir, 1450);
  }

  /* ── Puntero «Pulso vital» ────────────────────────────── */
  function puntero() {
    var el = document.getElementById("vcursor");
    if (!el) return;
    if (!window.matchMedia("(pointer: fine)").matches || reducido) {
      el.remove();
      return;
    }
    raiz.classList.add("has-vcursor");
    var INTERACTIVOS = "a, button, [role='button'], input, select, textarea, label, summary";
    var x = innerWidth / 2, y = innerHeight / 2, tx = x, ty = y, visto = false;
    (function bucle() {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      el.style.transform = "translate3d(" + x + "px," + y + "px,0)";
      requestAnimationFrame(bucle);
    })();
    addEventListener("mousemove", function (e) {
      tx = e.clientX;
      ty = e.clientY;
      if (!visto) {
        visto = true;
        x = tx;
        y = ty;
        el.classList.add("is-on");
      }
    }, { passive: true });
    document.addEventListener("mouseover", function (e) {
      var t = e.target;
      el.classList.toggle("is-link", !!(t && t.closest && t.closest(INTERACTIVOS)));
    }, { passive: true });
    addEventListener("mousedown", function () { el.classList.add("is-down"); });
    addEventListener("mouseup", function () { el.classList.remove("is-down"); });
    raiz.addEventListener("mouseleave", function () { el.classList.remove("is-on"); });
    raiz.addEventListener("mouseenter", function () { if (visto) el.classList.add("is-on"); });
  }

  /* ── Cabecera ─────────────────────────────────────────── */
  function cabecera() {
    var barra = document.querySelector("[data-cabecera]");
    if (!barra) return;
    var sombra = function () { barra.classList.toggle("is-scrolled", scrollY > 10); };
    sombra();
    addEventListener("scroll", sombra, { passive: true });

    // Desplegables de escritorio: por estado, se cierran al hacer clic o con Escape.
    barra.querySelectorAll("[data-drop]").forEach(function (item) {
      var panel = item.querySelector(".navdrop");
      var enlace = item.querySelector("[data-drop-enlace]");
      var abrir = function (si) {
        panel.classList.toggle("is-open", si);
        if (enlace) enlace.setAttribute("aria-expanded", si ? "true" : "false");
      };
      item.addEventListener("mouseenter", function () { abrir(true); });
      item.addEventListener("mouseleave", function () { abrir(false); });
      item.addEventListener("focusin", function () { abrir(true); });
      item.addEventListener("focusout", function (e) {
        if (!item.contains(e.relatedTarget)) abrir(false);
      });
      panel.addEventListener("click", function () { abrir(false); });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      barra.querySelectorAll(".navdrop.is-open").forEach(function (p) { p.classList.remove("is-open"); });
      cerrarCajon();
    });

    // Cajón móvil
    var cajon = document.querySelector("[data-cajon]");
    var abrirBtn = barra.querySelector("[data-cajon-abrir]");
    function cerrarCajon() {
      if (!cajon || !cajon.classList.contains("is-open")) return;
      cajon.classList.remove("is-open");
      cajon.setAttribute("inert", "");
      raiz.style.overflow = "";
      if (abrirBtn) {
        abrirBtn.setAttribute("aria-expanded", "false");
        abrirBtn.focus();
      }
    }
    if (cajon && abrirBtn) {
      abrirBtn.addEventListener("click", function () {
        cajon.classList.add("is-open");
        cajon.removeAttribute("inert");
        raiz.style.overflow = "hidden";
        abrirBtn.setAttribute("aria-expanded", "true");
      });
      cajon.querySelectorAll("[data-cajon-cerrar]").forEach(function (b) {
        b.addEventListener("click", cerrarCajon);
      });
      cajon.querySelectorAll("[data-acordeon]").forEach(function (b) {
        b.addEventListener("click", function () {
          var id = b.getAttribute("aria-controls");
          var p = document.getElementById(id);
          var abierto = b.getAttribute("aria-expanded") === "true";
          b.setAttribute("aria-expanded", abierto ? "false" : "true");
          if (p) p.hidden = abierto;
        });
      });
    }
  }

  /* ── CTA fija de un programa (aparece al pasar el hero) ── */
  function ctaFija() {
    var cta = document.querySelector("[data-cta-fija]");
    var ancla = document.querySelector("[data-cta-ancla]");
    if (!cta || !ancla || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (e) {
      var ver = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      cta.classList.toggle("is-on", ver);
      document.body.setAttribute("data-sticky", ver ? "1" : "0");
    }).observe(ancla);
  }

  /* ── Enlaces a la plataforma: [plataforma] en un href ─── */
  /* Precios en vivo: se leen de la plataforma (panel > Programas / Salud / Paquetes). */
  function preciosVivos() {
    var nodos = document.querySelectorAll("[data-precio-vivo]");
    var base = (document.body.getAttribute("data-plataforma") || "").replace(/\/+$/, "");
    if (!nodos.length || !base) return;
    var pintar = function (cat) {
      nodos.forEach(function (n) {
        var it = cat && cat[n.getAttribute("data-precio-vivo")];
        if (it && it.precio_texto) {
          n.textContent = it.precio_texto;
          n.setAttribute("data-precio-ok", "1");
        }
      });
    };
    var llave = "vt-catalogo";
    try {
      var guardado = JSON.parse(sessionStorage.getItem(llave) || "null");
      if (guardado && guardado.hasta > Date.now()) { pintar(guardado.datos); return; }
    } catch (e) {}
    fetch(base + "/api/catalogo", { credentials: "omit", mode: "cors" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (datos) {
        if (!datos || !datos.items) return;
        pintar(datos.items);
        try { sessionStorage.setItem(llave, JSON.stringify({ hasta: Date.now() + 5 * 60 * 1000, datos: datos.items })); } catch (e) {}
      })
      .catch(function () {});
  }

  /* Carrito sin recargar: la ficha y el "Agregar" de las tarjetas usan /cart/add.js,
     actualizan el contador de la cabecera y muestran un aviso con "Ir al carrito". */
  function avisoCarrito(texto, enlace, error) {
    var viejo = document.querySelector(".vt-aviso");
    if (viejo) viejo.remove();
    var caja = document.createElement("div");
    caja.className = "vt-aviso" + (error ? " vt-aviso--error" : "");
    caja.setAttribute("role", "status");
    var t = document.createElement("span");
    t.textContent = texto;
    caja.appendChild(t);
    if (enlace) {
      var a = document.createElement("a");
      a.href = enlace.href;
      a.textContent = enlace.texto;
      caja.appendChild(a);
    }
    document.body.appendChild(caja);
    requestAnimationFrame(function () { caja.classList.add("is-in"); });
    setTimeout(function () { caja.classList.remove("is-in"); setTimeout(function () { caja.remove(); }, 400); }, 4200);
  }
  function pintarConteoCarrito(cantidad) {
    document.querySelectorAll('[data-cabecera] a[href$="/cart"]').forEach(function (a) {
      var globo = a.querySelector("span");
      if (!globo) {
        globo = document.createElement("span");
        globo.className = "absolute -right-1 -top-1 grid h-5 min-w-5 place-items-center rounded-full bg-oro px-1 text-[0.65rem] font-extrabold text-bosque";
        a.appendChild(globo);
      }
      globo.textContent = String(cantidad);
      globo.hidden = cantidad < 1;
    });
  }
  function agregarAlCarrito(cuerpo, boton) {
    var textos = document.body.dataset;
    var etiqueta = boton ? boton.querySelector("[data-agregar-texto], span") : null;
    var original = etiqueta ? etiqueta.innerHTML : "";
    if (boton) { boton.disabled = true; boton.setAttribute("aria-busy", "true"); if (etiqueta) etiqueta.textContent = textos.txtAgregando || "…"; }
    return fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: cuerpo, credentials: "same-origin" })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json && res.json.description);
        return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        pintarConteoCarrito(cart.item_count);
        avisoCarrito(textos.txtAgregado || "Agregado", { href: "/cart", texto: textos.txtIrCarrito || "Ir al carrito" });
      })
      .catch(function (e) {
        avisoCarrito((e && e.message) || textos.txtErrorCarrito || "No se pudo agregar", null, true);
      })
      .then(function () {
        if (boton) { boton.disabled = false; boton.removeAttribute("aria-busy"); if (etiqueta) etiqueta.innerHTML = original; }
      });
  }
  function carritoRapido() {
    var form = document.querySelector("[data-form-producto]");
    if (form && !form.hasAttribute("data-externo")) {
      form.addEventListener("submit", function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        agregarAlCarrito(new FormData(form), form.querySelector("[data-agregar]"));
      });
    }
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-agregar-rapido]");
      if (!b) return;
      e.preventDefault();
      var datos = new FormData();
      datos.append("id", b.getAttribute("data-agregar-rapido"));
      datos.append("quantity", "1");
      agregarAlCarrito(datos, b);
    });
  }

  /* Cifras de la comunidad: cuentan desde cero al entrar en pantalla; si la
     sección lee de la plataforma, el número real reemplaza al escrito. */
  function contadores() {
    var secciones = document.querySelectorAll("[data-cifras]");
    if (!secciones.length) return;
    var animar = function (nodo, meta) {
      var inicio = null, desde = 0, dur = 1400;
      var fmt = new Intl.NumberFormat("es-CO");
      var paso = function (t) {
        if (!inicio) inicio = t;
        var p = Math.min(1, (t - inicio) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        nodo.textContent = fmt.format(Math.round(desde + (meta - desde) * e));
        if (p < 1) requestAnimationFrame(paso);
      };
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) { nodo.textContent = fmt.format(meta); return; }
      requestAnimationFrame(paso);
    };
    var arrancar = function (sec) {
      var visibles = 0;
      sec.querySelectorAll("[data-cifra]").forEach(function (n) {
        var meta = Number(String(n.getAttribute("data-valor")).replace(/[^0-9]/g, "")) || 0;
        var tarjeta = n.closest("[data-reveal]");
        // Una cifra en cero no se muestra: mejor nada que un "0+".
        if (meta < 1) { if (tarjeta) tarjeta.hidden = true; return; }
        visibles += 1;
        n.textContent = "0";
        animar(n, meta);
      });
      if (!visibles) sec.hidden = true;
    };
    var base = (document.body.getAttribute("data-plataforma") || "").replace(/\/+$/, "");
    secciones.forEach(function (sec) {
      var listo = false;
      var ir = function () {
        if (listo) return; listo = true;
        if (sec.hasAttribute("data-cifras-vivo") && base && window.fetch) {
          fetch(base + "/api/cifras", { credentials: "omit", mode: "cors" })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) {
              if (d) sec.querySelectorAll("[data-cifra]").forEach(function (n) {
                var k = n.getAttribute("data-cifra");
                if (k && typeof d[k] === "number" && d[k] > 0) n.setAttribute("data-valor", String(d[k]));
              });
            })
            .catch(function () {})
            .then(function () { arrancar(sec); });
        } else {
          arrancar(sec);
        }
      };
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (es) {
          if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); ir(); }
        }, { threshold: 0.2 });
        io.observe(sec);
        setTimeout(ir, 6000);
      } else {
        ir();
      }
    });
  }

  function plataforma() {
    var base = (document.body.getAttribute("data-plataforma") || "").replace(/\/+$/, "");
    if (!base) return;
    document.querySelectorAll('a[href*="[plataforma]"]').forEach(function (a) {
      a.href = a.getAttribute("href").replace("[plataforma]", base);
    });
  }

  /* ── Afiliados: el botón lleva a la tienda externa (URL guardada en el producto) en vez de agregar al carrito ── */
  function afiliado() {
    var f = document.querySelector("form[data-externo]");
    if (!f || !f.getAttribute("data-externo")) return;
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      window.open(f.getAttribute("data-externo"), "_blank", "noopener");
    });
  }

  /* ── [whatsapp] o [whatsapp:mensaje] escritos en un texto enriquecido ── */
  function whatsappEnTexto() {
    var wa = document.body.getAttribute("data-wa") || "";
    if (!wa) return;
    document.querySelectorAll('a[href^="[whatsapp"]').forEach(function (a) {
      var m = a.getAttribute("href").match(/^\[whatsapp(?::([^\]]*))?\]$/);
      if (!m) return;
      a.href = m[1] ? wa + encodeURIComponent(m[1]) : wa.replace(/\?text=$/, "");
      a.target = "_blank";
      a.rel = "noopener noreferrer";
    });
  }

  /* ── Marketplace: buscar, filtrar y ordenar en el navegador ── */
  function marketplace() {
    var raizM = document.querySelector("[data-marketplace]");
    if (!raizM) return;
    var plegable = raizM.querySelector("[data-mkt-filtros]");
    if (plegable && window.innerWidth < 1024) plegable.removeAttribute("open");
    var lista = raizM.querySelector("[data-mkt-lista]");
    var items = Array.prototype.slice.call(lista.children).filter(function (n) {
      return n.querySelector("[data-producto]");
    });
    var norma = function (t) {
      return (t || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
    };
    var estado = { q: "", categoria: "", vende: "", orden: "recomendados" };
    try {
      var previo = JSON.parse(sessionStorage.getItem("vitally-mkt") || "null");
      if (previo) estado = Object.assign(estado, previo);
    } catch (e) {}
    var param = new URLSearchParams(location.search).get("cat");
    if (param) estado.categoria = param;

    // Grupo «Vende», armado con lo que hay en el catálogo.
    var grupoVende = raizM.querySelector('[data-mkt-grupo="vende"]');
    var vendedores = [];
    items.forEach(function (n) {
      var v = n.querySelector("[data-producto]").getAttribute("data-vende");
      if (v && vendedores.indexOf(v) < 0) vendedores.push(v);
    });
    if (grupoVende && vendedores.length > 1) {
      var rot = document.createElement("span");
      rot.className = "mr-1 text-[0.66rem] font-bold uppercase tracking-[0.2em] text-humo";
      rot.textContent = grupoVende.getAttribute("aria-label");
      grupoVende.appendChild(rot);
      [""].concat(vendedores).forEach(function (v) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "mkt-chip";
        b.setAttribute("data-valor", v);
        b.setAttribute("aria-pressed", "false");
        b.textContent = v || raizM.querySelector('[data-mkt-grupo="categoria"] [data-valor=""]').textContent;
        grupoVende.appendChild(b);
      });
      grupoVende.hidden = false;
    }

    var buscar = raizM.querySelector("[data-mkt-buscar]");
    var orden = raizM.querySelector("[data-mkt-orden]");
    var conteo = raizM.querySelector("[data-mkt-conteo]");
    var vacio = raizM.querySelector("[data-mkt-vacio]");
    var limpiar = raizM.querySelector("[data-mkt-limpiar]");

    function pintar() {
      var q = norma(estado.q.trim());
      var visibles = items.filter(function (n) {
        var p = n.querySelector("[data-producto]");
        if (estado.categoria && p.getAttribute("data-categoria") !== estado.categoria) return false;
        if (estado.vende && p.getAttribute("data-vende") !== estado.vende) return false;
        if (q && norma(p.getAttribute("data-nombre")).indexOf(q) < 0) return false;
        return true;
      });
      var clave = {
        recomendados: function (n) { return Number(n.getAttribute("data-orden")); },
        recientes: function (n) { return -Number(n.querySelector("[data-producto]").getAttribute("data-fecha")); },
        precio: function (n) { return Number(n.querySelector("[data-producto]").getAttribute("data-precio")); },
      }[estado.orden];
      var ordenados = items.slice();
      if (estado.orden === "az") {
        ordenados.sort(function (a, b) {
          return a.querySelector("h3").textContent.localeCompare(b.querySelector("h3").textContent, "es");
        });
      } else {
        ordenados.sort(function (a, b) { return clave(a) - clave(b); });
      }
      ordenados.forEach(function (n) {
        lista.appendChild(n);
        n.hidden = visibles.indexOf(n) < 0;
        n.classList.add("is-in");
      });
      conteo.textContent = visibles.length;
      vacio.hidden = visibles.length > 0;
      limpiar.hidden = !(estado.q || estado.categoria || estado.vende);
      raizM.querySelectorAll("[data-mkt-grupo]").forEach(function (g) {
        var campo = g.getAttribute("data-mkt-grupo");
        g.querySelectorAll("[data-valor]").forEach(function (b) {
          b.setAttribute("aria-pressed", b.getAttribute("data-valor") === estado[campo] ? "true" : "false");
        });
      });
      if (buscar.value !== estado.q) buscar.value = estado.q;
      orden.value = estado.orden;
      try { sessionStorage.setItem("vitally-mkt", JSON.stringify(estado)); } catch (e) {}
    }

    buscar.addEventListener("input", function () { estado.q = buscar.value; pintar(); });
    orden.addEventListener("change", function () { estado.orden = orden.value; pintar(); });
    raizM.addEventListener("click", function (e) {
      var b = e.target.closest("[data-valor]");
      if (!b) return;
      var campo = b.closest("[data-mkt-grupo]").getAttribute("data-mkt-grupo");
      estado[campo] = b.getAttribute("data-valor");
      pintar();
    });
    limpiar.addEventListener("click", function () {
      estado = { q: "", categoria: "", vende: "", orden: estado.orden };
      pintar();
    });
    pintar();
  }

  /* ── Ficha: variantes y galería ─────────────────────── */
  function ficha() {
    var form = document.querySelector("[data-form-producto]");
    var datos = document.querySelector("[data-variantes]");
    var principal = document.querySelector("[data-galeria] .card-luz img");
    document.querySelectorAll("[data-miniatura]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!principal) return;
        principal.src = b.getAttribute("data-miniatura");
        principal.srcset = b.getAttribute("data-srcset");
        document.querySelectorAll("[data-miniatura]").forEach(function (o) { o.classList.toggle("border-oro", o === b); });
      });
    });
    if (!form || !datos) return;
    var variantes = JSON.parse(datos.textContent);
    var selects = form.querySelectorAll("[data-opcion]");
    var campo = form.querySelector("[data-variante]");
    var precio = document.querySelector("[data-precio]");
    var boton = form.querySelector("[data-agregar]");
    var texto = form.querySelector("[data-agregar-texto]");
    var textoListo = texto ? texto.textContent : "";
    var formato = function (c) {
      try {
        return new Intl.NumberFormat("es-CO", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "COP", maximumFractionDigits: 0 }).format(c / 100);
      } catch (e) { return "$" + Math.round(c / 100); }
    };
    selects.forEach(function (sel) {
      sel.addEventListener("change", function () {
        var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!v) return;
        campo.value = v.id;
        if (precio) precio.textContent = formato(v.price);
        boton.disabled = !v.available;
        if (texto) texto.textContent = v.available ? textoListo : (boton.getAttribute("data-agotado") || "Agotado");
        if (v.featured_image && principal) {
          principal.src = v.featured_image.src;
          principal.removeAttribute("srcset");
        }
        var url = new URL(location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState(null, "", url);
      });
    });
  }

  /* ── Filtro de rejillas (recursos por tipo) ───────────── */
  function filtros() {
    document.querySelectorAll("[data-filtro]").forEach(function (grupo) {
      var lista = grupo.parentNode.querySelector("[data-filtro-lista]");
      if (!lista) return;
      var param = new URLSearchParams(location.search).get("tipo");
      var aplicar = function (valor) {
        grupo.querySelectorAll("[data-filtro-valor]").forEach(function (b) {
          b.setAttribute("aria-pressed", b.getAttribute("data-filtro-valor") === valor ? "true" : "false");
        });
        lista.querySelectorAll("[data-filtro-item]").forEach(function (n) {
          n.hidden = !!valor && n.getAttribute("data-filtro-item") !== valor;
          n.classList.add("is-in");
        });
      };
      grupo.addEventListener("click", function (e) {
        var b = e.target.closest("[data-filtro-valor]");
        if (b) aplicar(b.getAttribute("data-filtro-valor"));
      });
      if (param && grupo.querySelector('[data-filtro-valor="' + param.replace(/"/g, "") + '"]')) aplicar(param);
    });
  }

  function iniciar() {
    plataforma();
    preciosVivos();
    carritoRapido();
    contadores();
    whatsappEnTexto();
    afiliado();
    entrada();
    revelar();
    puntero();
    cabecera();
    ctaFija();
    marketplace();
    filtros();
    ficha();
    document.dispatchEvent(new CustomEvent("vitally:listo"));
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
  document.addEventListener("shopify:section:load", function () {
    revelar();
    plataforma();
    preciosVivos();
    carritoRapido();
    contadores();
    whatsappEnTexto();
  });
})();
